import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  createRef,
  useMemo,
  useCallback,
} from "react";
import SearchPanel from "@widgets/SearchPanel"; // 조회조건 Panel
import { fnGetDataSet, fnSave } from "@shared/api/restApi"; // BackEnd API
import { getInitFormData } from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog"; // Message Box
import { global, globalMenu, useMenuStore } from "@shared/libs/Global"; // Login User관련 전역 변수( 로그인 정보)
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnTree from "@shared/components/GridV2/SnTree";
import { menuInfo } from "@shared/type/CommonType";
import { showPopupModal } from "@widgets/CommonModal";
import SnButton from "@shared/components/SnButton";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import SnResizeBar from "@shared/components/SnResizeBar";
import { dateToString } from "@shared/utils/DateUtils";
import { RowNode } from "ag-grid-community";
import { ColDef } from "ag-grid-community";
import { v4 as uuid } from "uuid";
import SN_PMS_PJT_REG_004_POP_001 from "./SN_PMS_PJT_REG_004_POP_001";
import SN_PMS_PJT_REG_004_POP_002 from "./SN_PMS_PJT_REG_004_POP_002";
interface Props {
  Menuprops: menuInfo;
}

const SN_PMS_PJT_REG_004 = forwardRef(({ Menuprops }: Props, ref) => {
  const { userInfo } = global();
  const { menuItems } = useMenuStore();

  const searchRef = useRef<any>(null);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    tree: React.createRef(),
    grid: React.createRef(),
  });
  const nodeFilterRef = useRef<string[]>([]);

  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    tree: [],
    grid: [],
    sheet1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    tree: [],
    grid: [],
    sheet1: [],
  });

  const [dSExcel, setdSExcel] = useState<any>(); // sheet datasource 관련

  const sheetref1 = useRef<any>(null); // excel download 용
  const [isTreeExpanded, setIsTreeExpanded] = useState<boolean>(true);

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums({
          tree: rtn.grid.grid1,
          grid: rtn.grid.grid2,
          sheet1: rtn.grid.sheet1,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
    onExcelUpload,
    onExcelDownLoad,
  }));

  const onSearch = async () => {
    try {
      const form = searchRef.current?.getFormdata?.() ?? {};

      if (!form?.cd_pjt?.trim()) {
        // showDialog("alter", "프로젝트 코드를 선택하시기 바랍니다");
        return false;
      }

      if (!form?.cd_item?.trim()) {
        // showDialog("alter", "품목을 선택하시기 바랍니다");
        return false;
      }

      const modifiedRows = gridRefs.current["grid"].current.getChange();
      if (modifiedRows.modifiedRowcount > 0) {
        const confirm = await showDialog(
          "confirmCancel",
          "수정된 내용이 있습니다. 저장하시겠습니까?"
        );
        if (confirm) {
          const isSaved: any = await onSave();
          if (!isSaved) {
            return;
          }
        } else if (confirm === undefined) {
          return;
        }
      }

      const params = {
        id: "sn_pms_pjt_reg_004_01",
        params: form,
      };

      gridRefs.current["tree"].current.resetUpdate();
      gridRefs.current["grid"].current.resetUpdate();
      const data: any = await fnGetDataSet(params);
      if (data) {
        const treeData = convertToTreeData(data[0]);
        setDataSources({
          tree: treeData,
          grid: data[0] || [],
          sheet1: data[0] || [],
        });
      }
    } catch (error) {}
  };

  // const onInsert = async () => {
  //   const treeApi = gridRefs.current["tree"].current;
  //   const gridApi = gridRefs.current["grid"].current;

  //   if (!treeApi || !gridApi) return;

  //   const selectedNodes = treeApi.getSelectedNodes?.() || [];
  //   if (selectedNodes.length === 0) {
  //     await showDialog("alter", "품목을 선택해주세요.");
  //     return;
  //   }

  //   try {
  //     // 실제 EBOM 기본값 세팅은 onBeforeAddRow 에서 공통 처리
  //     gridApi.addRow({});
  //     const rowCount = gridApi.getDisplayedRowCount();
  //     if (rowCount > 0) {
  //       gridApi.selectAndFocusRow(rowCount - 1);
  //     }
  //   } catch (error: any) {
  //     console.error("EBOM onInsert error", error);
  //   }
  // };

  const onInsert = async () => {
    // const treeApi = gridRefs.current["tree"].current;
    // const gridApi = gridRefs.current["grid"].current;
    // if (!treeApi || !gridApi) return;
    // const selectedNodes = treeApi.getSelectedNodes?.() || [];
    // if (selectedNodes.length === 0) {
    //   await showDialog("alter", "품목을 선택해주세요.");
    //   return;
    // }
    // try {
    //   const parentRow = selectedNodes[0].data;
    //   const form = searchRef.current?.getFormdata?.() ?? {};
    //   const parentItem = parentRow.cd_matl || parentRow.cd_item;
    //   if (!parentItem) {
    //     return;
    //   }
    //   // 현재 그리드 데이터 기준으로, 같은 부모(cd_item)를 가진 형제 라인들의 no_line 최대값 계산
    //   const siblings = (dataSources.grid || []).filter(
    //     (r: any) => r.cd_item === parentItem
    //   );
    //   const baseNoLine = siblings.reduce((max: number, r: any) => {
    //     const v = Number(r.no_line || 0);
    //     return v > max ? v : max;
    //   }, 0);
    //   // 신규 EBOM 라인 기본값 세팅
    //   const newRow: any = {};
    //   initNewRow(newRow, parentRow, form, baseNoLine, 0);
    //   const addedNode = gridApi.addRow(newRow);
    //   if (addedNode) {
    //     const rowIndex =
    //       typeof addedNode.rowIndex === "number"
    //         ? addedNode.rowIndex
    //         : gridApi.getDisplayedRowCount() - 1;
    //     gridApi.selectAndFocusRow(rowIndex);
    //   }
    // } catch (error: any) {
    //   console.error("EBOM onInsert error", error);
    // }
  };

  const onDelete = () => {
    const rowCount = gridRefs.current["grid"].current.getDisplayedRowCount();
    if (rowCount == 0) return;
    gridRefs.current["grid"].current?.deleteSelectedRows();
  };

  const onSave = async () => {
    try {
      gridRefs.current["grid"].current.stopEditing();

      const requiredValuesCheckH =
        gridRefs.current["grid"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return false;
      }

      const gridGetChanges = gridRefs.current["grid"].current.getChange();
      if (gridGetChanges.modifiedRowcount == 0) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return false;
      }

      // const hasInvalidcddemp = [
      //   ...(gridGetChanges.insert || []),
      //   ...(gridGetChanges.update || []),
      // ].some((item) => item.cd_emp && item.cd_emp.length > 20);

      // if (hasInvalidcddemp) {
      //   await showDialog("alter", "사원코드가 20자리를 초과하였습니다.");
      //   return false;
      // }

      // const hasInvalidnopostr = [
      //   ...(gridGetChanges.insert || []),
      //   ...(gridGetChanges.update || []),
      // ].some((item) => item.no_post_r && item.no_post_r.length > 6);

      // if (hasInvalidnopostr) {
      //   await showDialog("alter", "우편번호가 6자리를 초과하였습니다.");
      //   return false;
      // }

      const SaveData = {
        pms_pjt_ebom: gridRefs.current["grid"].current.getChange(),
      };

      const ok = await fnSave("SN_PMS_PJT_REG_004_SAVE_01", SaveData);
      if (!ok) {
        return;
      }

      gridRefs.current["grid"].current.resetUpdate();
      return true;
    } catch (error: any) {
      return false;
    }
  };

  const onExcelDownLoad = async () => {
    try {
      const displayedCols = sheetref1.current?.getAllDisplayedColumns() || [];
      const columnKeys = displayedCols.map((c: any) => c.getColId());

      sheetref1.current?.exportDataAsExcel({
        columnKeys,
        skipPinnedBottom: true,
        fileName: `${globalMenu.getState().activeMenuInfo.nm_menu}.xlsx`,
        sheetName: "Sheet1",
      });
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onExcelUpload = async () => {
    try {
      const form = searchRef.current.getFormdata();
      if (!form.cd_pjt?.trim()) {
        await showDialog("alter", "프로젝트를 선택해 주세요.");
        return false;
      }
      if (!form.cd_item?.trim()) {
        await showDialog("alter", "모품목을 선택해 주세요.");
        return false;
      }
      const component = (
        <SN_PMS_PJT_REG_004_POP_001
          Menuprops={Menuprops} // 메뉴 정보 전달
          searchParams={{
            cd_firm: userInfo?.cd_firm ?? "",
            cd_pjt: form.cd_pjt,
            cd_unit: form.cd_item, // unit 파라미터명에 모품목 값 전달
          }}
          controllerName="SN_PMS_PJT_REG_004_SAVE_01" // 저장할 컨트롤러 이름
          userInfo={userInfo} // userInfo={userInfo}
        />
      );

      const result = await showPopupModal({
        title: "엑셀 업로드",
        children: component,
        width: "80%",
        height: "90VH",
        okayBtnText: "저장",
      });

      if (result) {
        await onSearch();
      }
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const autoGroupColumnDef = useMemo<ColDef>(() => {
    return {
      headerName: "품목",
      field: "cd_matl_display",
      flex: 1, // 화면 가득 차게
      minWidth: 300,
      editable: false,
      cellRendererParams: {
        suppressCount: true, // 하위 아이템 개수 숨기기
        suppressDoubleClickExpand: true, // 더블 클릭으로 확장/축소 비활성화
        suppressHoverHighlight: false,
      },
    };
  }, []);

  const collectMatls = (node: any): string[] => {
    if (!node) return [];

    const matls: string[] = [];

    if (node.data?.cd_matl) {
      matls.push(node.data.node);
    }

    if (node.childrenAfterGroup?.length) {
      node.childrenAfterGroup.forEach((child: any) => {
        matls.push(...collectMatls(child));
      });
    }

    return matls;
  };

  const onFocusedRowChanged = (event: any) => {
    const selectedNode = event;
    if (!selectedNode) return;

    const gridApi = gridRefs.current["grid"].current;
    if (!gridApi) return;

    const allCdMatls = collectMatls(selectedNode);

    if (allCdMatls.length > 0) {
      nodeFilterRef.current = allCdMatls;
      gridApi.applyFilters({
        node: allCdMatls,
      });
    } else {
      nodeFilterRef.current = [];
      gridApi.resetFilters();
    }

    const rowCount = gridApi.getDisplayedRowCount();
    if (rowCount > 0) {
      gridApi.selectAndFocusRow(0);
    }
  };

  const getRowId = useCallback(
    (params: any) => String(params.data.node || params.data.cd_matl),
    []
  );

  const onGrid1BtnsClick = async (id: string) => {
    const api = gridRefs.current["tree"].current;
    if (!api) return;

    if (id === "btnToggleExpand") {
      api.setExpandedAll(!isTreeExpanded);
      setIsTreeExpanded(!isTreeExpanded);
    }
    if (id === "btnPhaseAdd") {
      const form = searchRef.current?.getFormdata?.() ?? {};
      const selectedNodes = api.getSelectedNodes?.() || [];
      if (!form?.cd_pjt?.trim()) {
        await showDialog("alter", "프로젝트를 선택해주세요.");
        return;
      }
      if (selectedNodes.length === 0) {
        await showDialog("alter", "차수추가할 반제품을 선택하세요.");
        return;
      }
      const parentNode = selectedNodes[0];
      const selectedItem =
        parentNode?.data?.cd_matl || parentNode?.data?.cd_item;
      if (!selectedItem) {
        return;
      }
      if (parentNode?.data?.cd_dummy03 !== "5") {
        await showDialog("alter", "반제품을 선택해 주세요");
        return;
      }

      const component = (
        <SN_PMS_PJT_REG_004_POP_002
          modalRef={ref}
          Menuprops={Menuprops}
          initialParams={{
            cd_pjt: form.cd_pjt,
            cd_unit: form.cd_item,
            cd_item: selectedItem,
            nm_pjt: form.nm_pjt,
            nm_st_pjt: form.nm_st_pjt,
          }}
        />
      );

      const result = await showPopupModal({
        title: "차수추가",
        children: component,
        width: "90%",
        height: "90%",
      });

      if (result && result !== "close") {
        await onSearch();
      }
    }
  };

  const convertToTreeData = (rows: any[]) => {
    if (!rows || rows.length === 0) return [];

    return rows.map((row) => ({
      ...row,

      node: row.node ?? row.cd_matl,
      node_p: row.node_p ?? row.cd_item,
      cd_matl_display: row.cd_matl_display ?? `${row.cd_matl} - ${row.nm_matl}`,
      sort_key: row.sort_key !== undefined ? Number(row.sort_key) : 0,
    }));
  };

  const onRowDataReady = () => {
    gridRefs.current["tree"].current.selectAndFocusRow(0);
    gridRefs.current["grid"].current.selectAndFocusRow(0);
  };

  // EBOM 신규 행 초기화 공통 함수
  const initNewRow = (
    row: any,
    parentRow: any,
    form: any,
    baseNoLine: number,
    offset: number
  ) => {
    const parentItem = parentRow.cd_matl || parentRow.cd_item;
    const parentLevel = Number(parentRow.no_level ?? 0);
    const parentDepth = Number(parentRow.depth ?? 0);

    // 공통키
    if (!row.cd_firm) row.cd_firm = userInfo.cd_firm;
    if (!row.cd_pjt) row.cd_pjt = form.cd_pjt;
    if (!row.cd_unit) row.cd_unit = form.cd_item;
    if (row.no_hst === undefined || row.no_hst === null)
      row.no_hst = parentRow.no_hst ?? 0;
    if (!row.no_rev) row.no_rev = parentRow.no_rev ?? "";

    // 트리용 키
    if (!row.node) row.node = uuid();
    if (!row.node_p) row.node_p = parentRow.node;

    // EBOML 구조
    row.cd_item = parentItem;
    if (row.no_line === undefined || row.no_line === null)
      row.no_line = baseNoLine + 1 + offset;

    if (row.no_level === undefined || row.no_level === null)
      row.no_level = parentLevel + 1;
    if (row.depth === undefined || row.depth === null)
      row.depth = parentDepth + 1;

    // 기본값
    if (row.qt_use === undefined || row.qt_use === null) row.qt_use = 1;
    if (row.fg_eco === undefined) row.fg_eco = null;
    if (!row.dc_rmk) row.dc_rmk = "";

    // 설계 품목 관련 기본값 (없는 경우만 채움)
    if (row.cd_matl === undefined || row.cd_matl === null) row.cd_matl = "";
    if (row.cd_matl_design === undefined || row.cd_matl_design === null)
      row.cd_matl_design = "";

    if (!row.nm_matl) row.nm_matl = "";
    if (!row.dc_matl_spec) row.dc_matl_spec = "";
    if (!row.dc_matl_unit) row.dc_matl_unit = "";
    if (!row.dc_material) row.dc_material = "";

    if (!row.cd_dummy01) row.cd_dummy01 = "";
    if (!row.cd_dummy02) row.cd_dummy02 = "";
    if (!row.cd_dummy03) row.cd_dummy03 = "";
    if (!row.cd_dummy04) row.cd_dummy04 = "";
    if (!row.cd_dummy05) row.cd_dummy05 = "";

    if (row.yn_sync === undefined) row.yn_sync = null;
    if (row.tm_sync === undefined) row.tm_sync = null;
    if (!row.cd_emp_sync) row.cd_emp_sync = "";
  };

  const getBaseNoLine = (gridApi: any, parentItem: string) => {
    let baseNoLine = 0;
    gridApi.forEachNode?.((node: any) => {
      if (node?.data?.cd_item === parentItem) {
        const v = Number(node.data.no_line || 0);
        if (v > baseNoLine) baseNoLine = v;
      }
    });
    return baseNoLine;
  };

  const addChildRows = async (rows?: any[]) => {
    const treeApi = gridRefs.current["tree"].current;
    const gridApi = gridRefs.current["grid"].current;
    if (!treeApi || !gridApi) return;

    const selectedNodes = treeApi.getSelectedNodes?.() || [];
    if (selectedNodes.length === 0) {
      await showDialog("alter", "품목을 선택해주세요.");
      return;
    }

    const parentRow = selectedNodes[0].data;
    const parentItem = parentRow.cd_matl || parentRow.cd_item;
    if (!parentItem) {
      await showDialog("alter", "부모 품목을 확인해주세요.");
      return;
    }

    const targetRows = rows && rows.length > 0 ? rows : [{}];
    const form = searchRef.current?.getFormdata?.() ?? {};
    const baseNoLine = getBaseNoLine(gridApi, parentItem);

    const addedNodes: string[] = [];

    targetRows.forEach((r, idx) => {
      const newRow = { ...r };
      initNewRow(newRow, parentRow, form, baseNoLine, idx);
      const added = gridApi.addRow(newRow);
      if (added?.data?.node) {
        addedNodes.push(String(added.data.node));
      }
    });

    // 필터가 활성화된 상태라면, 추가된 노드도 필터 값에 포함시켜 가려지지 않게 한다.
    if (nodeFilterRef.current.length > 0 && addedNodes.length > 0) {
      const merged = Array.from(
        new Set([...nodeFilterRef.current, ...addedNodes])
      );
      nodeFilterRef.current = merged;
      gridApi.applyFilters({ node: merged });
    } else if (nodeFilterRef.current.length === 0) {
      gridApi.resetFilters();
    }

    const rowCount = gridApi.getDisplayedRowCount();
    if (rowCount > 0) {
      gridApi.selectAndFocusRow(rowCount - 1);
    }
  };

  const onGridBtnsClick = async (id: string, rows?: any[]) => {
    if (id === "addRow") {
      await addChildRows(rows);
    }
    if (id === "deleteRow") {
      gridRefs.current["grid"].current?.deleteSelectedRows();
    }
  };

  const grids = useMemo(
    () => ({
      tree: {
        columns: columns.tree,
        dataSource: dataSources.tree,
        events: {
          onFocusedRowChanged,
          onRowDataReady: onRowDataReady,
        },
      },
      grid: {
        columns: columns.grid,
        dataSource: dataSources.grid,
        events: {
          onBtnAddClick: onGridBtnsClick,
          onBtnDeleteClick: onGridBtnsClick,
        },
      },
      sheet1: {
        columns: columns.sheet1,
        dataSource: dataSources.sheet1,
      },
    }),
    [columns, dataSources]
  );

  //#region UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        />
      </div>

      <div className="w-full flex h-full min-h-0 space-x-1.5">
        <SnResizeBar direction={"width"} id="panel1" orgSize="25%">
          <SnTree
            ref={gridRefs.current["tree"]}
            columnConfig={grids.tree.columns}
            rowData={grids.tree.dataSource}
            etcProps={{
              rowSelection: "single",
              title: "품목정보",
            }}
            header={
              <div>
                <SnButton
                  text={isTreeExpanded ? "전체닫기" : "전체전개"}
                  onClick={() => onGrid1BtnsClick("btnToggleExpand")}
                />
                <SnButton
                  text="차수추가"
                  onClick={() => onGrid1BtnsClick("btnPhaseAdd")}
                />
              </div>
            }
            events={grids.tree.events}
            treeProps={{
              treeDataParentIdField: "node_p",
              treeIdKey: "node",
              treeOrderKey: "sort_key",
              groupDefaultExpanded: 5,
              autoGroupColumnDef: autoGroupColumnDef,
              getRowId: getRowId,
            }}
          />
        </SnResizeBar>
        <SnResizeBar direction={"width"} id="panel2" orgSize="74.5%">
          <SnGrid
            ref={gridRefs.current["grid"]}
            columnConfig={grids.grid.columns}
            rowData={grids.grid.dataSource}
            etcProps={{
              rowSelection: "single",
              title: "BOM정보",
            }}
            events={grids.grid.events}
            header={
              <div>
                <SnButton
                  text="하위추가"
                  onClick={() => onGridBtnsClick("addRow")}
                />
              </div>
            }
          />
        </SnResizeBar>

        <div style={{ display: "none" }}>
          <SnGrid
            ref={sheetref1}
            columnConfig={grids.sheet1.columns}
            rowData={grids.sheet1.dataSource} // Datasource
            etcProps={{ isEditable: false }}
          />
        </div>
      </div>
    </div>
  );
});

export default SN_PMS_PJT_REG_004;
